import { ChangeDetectionStrategy, Component } from "@angular/core";
import { PublicationModel } from "../../../interfaces/publication-model";
import { PublicationTileComponent } from "../publication-tile/publication-tile.component";
import { PublicationService } from "../../../services/publication.service";
import { combineLatest, map, Observable, shareReplay, startWith } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { MatCard, MatCardContent } from "@angular/material/card";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { Router } from "@angular/router";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { PUBLICATION_URI } from "../../../variables/uri";

@Component({
    standalone: true,
    selector: "gwo-publication-list",
    imports: [
        PublicationTileComponent,
        AsyncPipe,
        MatCard,
        MatCardContent,
        FormsModule,
        MatInputModule,
        MatIcon,
        ReactiveFormsModule,
        MatButton,
    ],

    templateUrl: "./publication-list.component.html",
    styleUrl: "./publication-list.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicationListComponent {
    readonly publications$: Observable<PublicationModel[]>;
    readonly searchTerm = new FormControl("");
    readonly filteredPublications$: Observable<PublicationModel[]>;
    readonly publicationNames$: Observable<string[]>;

    constructor(
        private readonly publicationService: PublicationService,
        private readonly router: Router,
    ) {
        this.publications$ = this.publicationService
            .getPublications()
            .pipe(shareReplay(1));
        this.publicationNames$ = this.publications$.pipe(
            map((publications) => publications.map((pub) => pub.name)),
        );

        this.filteredPublications$ = combineLatest([
            this.publications$,
            this.searchTerm.valueChanges.pipe(startWith("")),
        ]).pipe(
            map(([publications, searchTerm]) =>
                publications.filter((pub) =>
                    pub.name
                        .toLowerCase()
                        .includes((searchTerm || "").toLowerCase()),
                ),
            ),
        );
    }

    openPublicationPage(): void {
        this.router.navigate([PUBLICATION_URI, "new"]);
    }
}
